// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qkFD","newExpiryDate":"styles_newExpiryDate__1QRjL","footer":"styles_footer__6iV8J"};